import React from 'react';
import { CheckIcon, FlameIcon, DownloadIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
const bundle = [{
  emoji: '🤖',
  label: 'MakerLab — Plus de 100 projets de robots',
  value: '$47.00'
}, {
  emoji: '🎥',
  label: 'Bonus n° 1 : Pack Arcade en carton',
  value: '$25.00'
}, {
  emoji: '✂️',
  label: 'Bonus n° 2 : Le guide des loisirs créatifs en 5 minutes',
  value: '$19.00'
}, {
  emoji: '🌈',
  label: 'Bonus n° 3 : Petits Créateurs : slimes et jeux sensoriels',
  value: '$19.00'
}];
export function Offer() {
  return <section id="offre" className="w-full bg-cream py-16 sm:py-24" data-id="element-120" data-mp="13yc9xpenils4">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-121" data-mp="ywwkzm9crv4g">
        <SectionHeading eyebrow="✦ Tout ce que vous recevez aujourd’hui" title={<>Le pack MakerLab complet</>} data-id="element-122" data-mp="2fc6aey0zjkmq" />

        <div className="mt-12 overflow-hidden rounded-3xl border border-ink/10 bg-white shadow-xl" data-id="element-123" data-mp="2ac1tx802upwi">
          <ul className="divide-y divide-ink/10" data-id="element-124" data-mp="pj5uqoeuwie0">
            {bundle.map(item => <li key={item.label} className="flex items-center justify-between gap-4 px-6 py-4" data-id="element-125" data-mp="uiimnnkl4fng">
                <span className="flex items-center gap-3 text-sm font-semibold text-ink" data-id="element-126" data-mp="zgafcjt205sp">
                  <span className="text-xl" aria-hidden="true" data-id="element-127" data-mp="13j72mntjgq2z">
                    {item.emoji}
                  </span>
                  {item.label}
                </span>
                <span className="flex-none text-sm font-medium text-ink/40 line-through" data-id="element-128" data-mp="btlubp8qzx7v">
                  {item.value}
                </span>
              </li>)}
          </ul>

          <div className="space-y-2 bg-ink px-6 py-8 text-center text-white" data-id="element-129" data-mp="km5voxgfcfwe">
            <p className="text-sm text-white/60" data-id="element-130" data-mp="3k95m0jtrt7kt">
              Valeur totale <span className="line-through" data-id="element-131" data-mp="3k6t4g7rxcz8a">$110.00</span>
            </p>
            <p className="flex items-center justify-center gap-2 text-sm font-semibold uppercase tracking-wide text-sunshine" data-id="element-132" data-mp="3o8o5db5y1alj">
              <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-133" data-mp="vde7b2r0ny4l" />
              Vous ne payez qu’aujourd’hui
            </p>
            <p className="font-display text-5xl font-black" data-id="element-134" data-mp="15620zomp9lz3">$19.00</p>
            <p className="text-sm font-semibold text-emerald-400" data-id="element-135" data-mp="157d4rog5atq7">
              🎉 Vous économisez $91.00 aujourd’hui
            </p>

            <div className="pt-4" data-id="element-136" data-mp="cgd1jfpn1tzl">
              <CtaButton href="https://pay.hotmart.com/F106899619N" className="w-full sm:w-auto" data-id="element-137" data-mp="cheks7gt5mse">
                Oui ! Je veux tout pour seulement $19
              </CtaButton>
            </div>

            <ul className="mt-6 flex flex-col items-center gap-2 text-sm text-white/70 sm:flex-row sm:justify-center sm:gap-6" data-id="element-138" data-mp="hfzf5q9dpc8x">
              {['Accès numérique instantané', 'Les 3 bonus inclus', 'Paiement unique, sans abonnement'].map(t => <li key={t} className="flex items-center gap-1.5" data-id="element-139" data-mp="20e4brtulkkq5">
                  <CheckIcon className="h-4 w-4 text-emerald-400" aria-hidden="true" data-id="element-140" data-mp="20h09pi6g39el" />
                  {t}
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-6 flex items-center justify-center gap-2 text-sm text-ink/50" data-id="element-141" data-mp="1vglyjr9jrjcc">
          <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-142" data-mp="2j4vfaerwlgwm" />
          Accès instantané après l’achat · Plus de 40 938 téléchargements
        </p>
      </div>
    </section>;
}